import { ALL_MENUS_QUERY } from './queries/menus'
import { sendNwReqWithAuth } from './network'
import { MENU_SLUGS } from '../utils/siteConfig'

const getAllMenus = async () => {
  const allMenusResp = await sendNwReqWithAuth(ALL_MENUS_QUERY)
  const menus = allMenusResp?.data?.menus?.nodes || []

  const getMenuItemsBySlug = slug => {
    const menuItems = menus?.filter(i => i?.slug === slug)
    // ?.map(i => i?.menuItems?.nodes);
    return menuItems?.[0] || []
  }

  const globalMenus = {
    header: {
      primary: getMenuItemsBySlug(MENU_SLUGS.header.primary),
      secondary: getMenuItemsBySlug(MENU_SLUGS.header.secondary),
    },
    footer: {
      leftCol: getMenuItemsBySlug(MENU_SLUGS.footer.leftCol),
      centralCol: getMenuItemsBySlug(MENU_SLUGS.footer.centralCol),
      rightCol: getMenuItemsBySlug(MENU_SLUGS.footer.rightCol),
      bottom: getMenuItemsBySlug(MENU_SLUGS.footer.bottom),
    },
    socialNetworks: getMenuItemsBySlug(MENU_SLUGS.socialNetworks),
  }

  return globalMenus || {}
}

export default getAllMenus
